import { Box, Paper } from "@mui/material";
import { SawFinishBundle } from "../models/types";
import { CardBodySx, CardPaperSx, CardTitle, InfoGrid } from "./primitives";

type Props = {
	data?: SawFinishBundle | null;
};

export const FinishBundleCard = ({ data = null }: Props) => (
	<Paper elevation={1} sx={CardPaperSx}>
		<CardTitle title="Finish Bundle" />

		<Box sx={CardBodySx}>
			<InfoGrid
				columns={1}
				items={[
					{ label: "Strap Length", value: data?.strapLength ?? null },
					{
						label: "Grooved Timber Length",
						value: data?.groovedTimberLength ?? null,
					},
					{ label: "Customer", value: data?.customer ?? null },
					{ label: "Customer Part #", value: data?.customerPartNumber ?? null },
				]}
			/>
		</Box>
	</Paper>
);
